var hmacSHA256 = require("crypto-js/hmac-sha256");
var sha256 = require("crypto-js/sha256");

function uriEncoded(uri, encodeSlash) {
    var result = "";
    for (var i = 0; i < uri.length; i++) {
        var ch = uri.charAt(i);
        if ((ch >= 'A' && ch <= 'Z') || (ch >= 'a' && ch <= 'z') || (ch >= '0' && ch <= '9') || ch == '_' || ch == '-' || ch == '~' || ch == '.' || ch == '&' || ch == '=') {
            result += ch;
        } else if (ch == '/') {
            result += encodeSlash ? "%2F" : ch;
        } else {
            result += hex(ch);
        }
    }
    return result.toString();
}

function getHashedCanonicalRequest(httpVerb, serviceUri, queryString, headers, payload) {
    var canonicalURI = serviceUri;
    var canonicalQueryString = uriEncoded(queryString).toString();

    var canonicalHeaders = "";
    var signedHeaders = "";
    for(var i = 0; i < headers.length; i++)
    {
        canonicalHeaders += `${headers[i][0]}:${headers[i][1]}\n`;
        signedHeaders += `${headers[i][0]};`;
    }
    signedHeaders = signedHeaders.slice(0, -1);

    var hashedPayload = sha256(payload).toString();
    var canonical = `${httpVerb}\n${canonicalURI}\n${canonicalQueryString}\n${canonicalHeaders}\n${signedHeaders}\n${hashedPayload}`;

    return sha256(canonical).toString();
}
function getStringToSign(algorithm, datetime, date, region, service, hashedCanonicalRequest) {
    return `${algorithm}\n${datetime}\n${date}/${region}/${service}/aws4_request\n${hashedCanonicalRequest}`;
}
function getSignature(secretKey, date, region, service, stringToSign) {
    const kDate = hmacSHA256(date, "AWS4" + secretKey)
    const kRegion = hmacSHA256(region, kDate)
    const kService = hmacSHA256(service, kRegion)
    const kSigning = hmacSHA256("aws4_request", kService);
    
    return hmacSHA256(stringToSign, kSigning).toString();
}
function getAuthorisation(algorithm, accessKey, date, region, service, signedHeaders, signature) {
    return `${algorithm} Credential=${accessKey}/${date}/${region}/${service}/aws4_request, SignedHeaders=${signedHeaders}, Signature=${signature}`;
}

function getAuthorisationHeader(accessKey, secretKey, verb, uri, query, headers, payload, date, datetime, region, service) {
    var algorithm = "AWS4-HMAC-SHA256";
    var signedHeaders = "";
    headers.sort();
    for(var i = 0; i < headers.length; i++) { signedHeaders += `${headers[i][0]};`; }
    signedHeaders = signedHeaders.slice(0, -1);

    var hashedCanonicalRequest = getHashedCanonicalRequest(verb, uri, query, headers, payload);
    var stringToSign = getStringToSign(algorithm, datetime, date, region, service, hashedCanonicalRequest);
    var signature = getSignature(secretKey, date, region, service, stringToSign);
    var authorisation = getAuthorisation(algorithm, accessKey, date, region, service, signedHeaders, signature);
    return authorisation;
}

module.exports = { getAuthorisationHeader }